import { useMemo } from 'react';
import { getTrendingPercent } from '@/utilites/sku-operations';
import { OrderMarketValue } from '@/types/utilities';
import checkArray from '@/utilites/check-array';
const useTrendingPercent = (
  orders: OrderMarketValue[],
  retailPrice: number
) => {
  return useMemo(() => {
    if (!checkArray(orders) && typeof retailPrice !== 'number') return 0;

    return getTrendingPercent({ orders, retailPrice });
  }, [orders, retailPrice]);
};

export default useTrendingPercent;
